import styled, { css } from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  HeadlineS,
  HeadlineXL,
  LabelS,
} from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

export const Wrapper = styled(Vertical).attrs({ gap: 2 })`
  justify-content: stretch;
  padding-top: var(--double-unit);
`;

export const Background = styled.div`
  padding: var(--half-unit);
  border-radius: var(--intermediate-unit);
  background: linear-gradient(
    84deg,
    #f8d3da 0%,
    #b3a9f4 28.32%,
    #fbe9fb 54.01%,
    #4f94fd 100%
  );
`;

export const Row = styled(Vertical).attrs({ gap: 0.5, center: true })`
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  @media ${tabletAndAbove} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: var(--half-unit);
  align-items: center;
  padding-bottom: var(--half-unit);
`;

export const Title = styled(HeadlineS)`
  text-transform: uppercase;
`;

export const BlockTitle = styled(HeadlineXL)`
  font-weight: normal;
  text-align: center;
  @media ${tabletAndAbove} {
    font: var(--t-headline-m);
    font-weight: normal;
  }
  @media ${laptopAndAbove} {
    font: var(--t-headline-xl);
    font-weight: normal;
  }
`;
export const StyledImg = styled.img`
  max-width: 400px;
  width: 100%;
  align-self: center;
`;

export const Disclaimer = styled(LabelS)`
  color: rgba(var(--c-rgb-neutral-1000), 0.5);
`;

export const Block = styled(Vertical)<{
  background?: string;
}>`
  justify-content: space-between;
  width: 100%;
  padding: var(--double-unit) var(--double-unit) 0;
  min-height: 320px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(var(--c-rgb-neutral-100), 0.88);

  ${({ background }) => css`
    background-image: url(${background});
  `}
  @media ${tabletAndAbove} {
    width: calc(33.333% - 2px);
    min-height: auto;
    aspect-ratio: 420 / 330;
    &:first-child {
      border-bottom-left-radius: var(--unit);
      border-top-left-radius: var(--unit);
    }
    &:last-child {
      border-bottom-right-radius: var(--unit);
      border-top-right-radius: var(--unit);
    }
  }
  @media ${laptopAndAbove} {
    padding: var(--triple-unit) var(--triple-unit) 0;
  }
`;

export const MiddleBlock = styled(Block)`
  padding-bottom: var(--triple-unit);
`;

export const Dismiss = styled(Button)`
  flex-grow: 0;
  justify-self: flex-end;
`;

export const StyledChip = styled(Chip).attrs({
  size: 'small',
  custom: {
    background: 'rgba(var(--c-rgb-neutral-1000), 0.11)',
    color: 'var(--c-neutral-1000)',
  },
})``;
